import { __require as requireGetBuiltIn } from './node_modules-core-js-internals-get-built-in.js';

var html;
var hasRequiredHtml;

function requireHtml () {
	if (hasRequiredHtml) return html;
	hasRequiredHtml = 1;
	var getBuiltIn = requireGetBuiltIn();

	html = getBuiltIn('document', 'documentElement');
	return html;
}

export { requireHtml as __require };
//# sourceMappingURL=node_modules-core-js-internals-html.js.map
